import axios from 'axios';
import { CheckoutRequest, CheckoutResponse, ProductResponse, ShowsResponse } from '../types/api';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

const api = axios.create({
  baseURL: API_BASE_URL,
});

export const getShows = async (): Promise<ShowsResponse> => {
  const response = await api.get<ShowsResponse>('/shows');
  return response.data;
};

export const getProduct = async (refId: string): Promise<ProductResponse> => {
  const response = await api.get<ProductResponse>(`/product/${refId}`);
  return response.data;
};

export const checkout = async (data: CheckoutRequest): Promise<CheckoutResponse> => {
  const response = await api.post<CheckoutResponse>('/checkout', data);
  return response.data;
}; 